import { X_Language, isMobile, throttle } from '@/utils';
import day from 'dayjs';
import { Base64 } from 'js-base64';
import Tracker from './tracker';

class GlobalTracker extends Tracker {
  /*
   *
   * @desc: 页面滚动百分比
   * @param {string} action 事件操作
   * @param {number} percentage 百分比
   *
   */
  pageViewPercentage = throttle(({ action, percentage }) => {
    if (percentage === 0) return;
    try {
      let label = '';
      let value = '';
      switch (action) {
        case 'view':
          label = `${window.location.pathname} + ${percentage}%`;
          break;
        default:
      }
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_page_view_percent`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  }, 500);

  /*
   *
   * @desc: 导航栏事件埋点
   * @param {string} action 事件操作
   *
   */
  navigation = ({ action, eventLabel }) => {
    try {
      let label = '';
      let value = '';
      switch (action) {
        case 'menu_toggle':
        case 'menu_item_click':
        case 'menu_personal_toggle':
        case 'menu_personal_item_click':
        case 'menu_personal_item_expose':
        case 'back_to_homepage':
          label = eventLabel;
          break;
        default:
          label = eventLabel;
          break;
      }
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_navigation_bar`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: FB直播相关事件
   * @param {string} action 事件操作
   *
   */
  FBLive = ({ action, eventLabel }) => {
    if (!eventLabel) return;
    try {
      let label = '';
      let value = '';
      switch (action) {
        case 'live_play':
        case 'live_close':
          label = eventLabel;
          break;
        default:
      }
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_fb_live`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 活动页视频播放
   * @param {string} action 事件操作
   *
   */
  CampaignVideo = ({ action, eventLabel }) => {
    if (!eventLabel) return;
    try {
      let label = '';
      let value = '';
      switch (action) {
        case 'video_play':
        case 'video_close':
          label = eventLabel;
          break;
        default:
      }
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_campaign_video`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 活动页
   * @param {string} action 事件操作
   * @param {string} eventLabel 事件标签
   *
   */
  Campaign = ({ action, eventLabel, value, campaignName = '' }) => {
    if (!eventLabel) return;
    try {
      let label = eventLabel || '';
      let _value = value || '';

      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_campaign${campaignName ? `_${campaignName}` : ''}`,
        action,
        label,
        value: _value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 黑五电话订阅
   *
   */
  BF = ({ action, isMobile }) => {
    // if (!eventLabel) return;
    try {
      this.commonTracker({
        category: `${isMobile ? 'mobile' : 'pc'}_2023BFsale_subscribe`,
        action,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * 用户登录注册等事件
   * @param {action}
   * @param {eventLabel}
   * @returns
   */
  UserAuthTracker = ({ action, value = 1 }) => {
    try {
      const time = day().format('YYYY-MM-DD HH:mm:ss');
      const label = `${window.location.pathname}_${X_Language}_${time}`;

      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_userAuth`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.error(e);
    }
  };

  /*
   *
   * @desc: 用户订阅窗口
   * @param {string} action 事件操作
   * @param {string} eventLabel 事件标签
   *
   */
  UserSubscribeEmail = ({ action, eventLabel }) => {
    if (!eventLabel) return;
    try {
      let label = eventLabel || '';
      let value = '';

      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_subscribe_email`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 用户订阅窗口（新
   * @param {string} action 事件操作
   * @param {string} eventLabel 事件标签
   *
   */
  UserSubscribeEmailNew = ({ action, eventLabel }) => {
    if (!eventLabel) return;
    try {
      let label = eventLabel || '';
      let value = '';

      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_subscribe_popup`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 右下角浮动工具栏
   * @param {string} action 事件操作
   * @param {string} eventLabel 事件标签
   *
   */
  PageToolBar = ({ action, eventLabel }) => {
    if (!eventLabel) return;
    try {
      let label = eventLabel || '';
      let value = '';

      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_page_tool_bar`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 页脚
   * @param {string} action 事件操作
   * @param {string} eventLabel 事件标签
   *
   */
  Footer = ({ action, eventLabel }) => {
    if (!eventLabel) return;
    try {
      let label = eventLabel || '';
      let value = '';

      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_footer`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @desc: 地区选择器
   *
   */
  AreaSelector = ({ action, eventLabel = '' }) => {
    try {
      let label = eventLabel || '';
      let value = '';

      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_area_selector`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @desc: 地区确认/修改（移动端）
   *
   */
  AreaConfirmModal = ({ action, eventLabel = '', areaState }) => {
    if (!areaState || !areaState?.country) return;
    try {
      let label = eventLabel || areaState?.country?.code || '';
      let value = '';

      this.commonTracker({
        category: `mobile_area_confirm_modal`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * @description 图文导航埋点
   */

  GraphicNav = ({ isMobile, action, eventLabel = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile ? 'mobile' : 'pc'}_pic_nav`,
        action,
        label: eventLabel,
        value: 1,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * @description 首页banner埋点
   *
   */
  HomePageBanner = ({ isMobile, action, eventLabel = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile ? 'mobile' : 'pc'}_homepage_banner`,
        action,
        label: eventLabel,
        value: 1,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @description 统计 4xx; 5xx；页面地区不可用
   *
   */
  ErrorPage = ({ action = '', eventLabel = '', eventValue = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_error_page`,
        action,
        label: eventLabel,
        value: eventValue,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @description 客服系统
   */
  CustomService = ({ action = 'click', label = '' }) => {
    this.commonTracker({
      category: `${isMobile() ? 'mobile' : 'pc'}_custom_service_entrance`,
      action,
      label,
      value: 1,
    });
  };

  /**
   * @description 首页埋点
   *
   */
  HomePage = ({ category, action = '', label = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_homepage_${category}`,
        action,
        label,
        value: 1,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * @description 云存储管理页
   */
  CloudManage = ({ action = '', label = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_cloud_manage`,
        action,
        label,
        value: 1,
      });
    } catch (e) {
      console.error(e);
    }
  };

  /**
   *
   * @description 商城底部订阅
   */
  StoreSubribeEmail = ({ action = '', label = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_page_subscribe`,
        action,
        label,
        value: 1,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @description 邮箱订阅请求（记录所有订阅）
   * @param data {Object} 活动页面
   * @param data.activityPage {string} 活动页面
   * @param data.success {Boolean} 订阅状态，true为订阅成功，false为订阅失败
   * @param data.email {String} 当前订阅邮箱
   */
  EmailSubscribeSubmit = ({ activityPage, success, email }) => {
    try {
      this.DataLayerEventPush({
        event: 'email_subscribe', // 固定值
        category: activityPage, // 当前活动
        action: `subscribe_${success ? 'success' : 'fail'}`,
        label: Base64.encode(email), // 邮箱base64编码
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @description cookiebot埋点
   */
  CookieBot = ({ action = '', label = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_cookie_preferences`,
        action,
        label,
        value: 1,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @description 公共埋点
   */
  Common = ({ category = '', action = '', label = '', value = 1, isMobile: _isMobile }) => {
    try {
      if (!category) return;
      this.commonTracker({
        category: `${_isMobile ?? isMobile() ? 'mobile' : 'pc'}_${category}`,
        action,
        label,
        value: value || 1,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @description 视频购物弹窗埋点
   */
  VideoShoppingGuide = ({ action = '', label = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_video_shopping_guide`,
        action,
        label,
        value: 1,
      });
    } catch (e) {
      console.log(e);
    }
  };
}

const T = new GlobalTracker();
export default T;
